"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Container from "ui/Container"
import { extractProperty, replaceRichTextLinks } from "utils"

const StyledProperty = styled.div`
  padding-top: 32px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
    padding-bottom: 64px;
  }

  table {
    border-collapse: collapse;
    width: 100%; // Make table take full width of container
    display: flex;
    overflow-x: auto; // Allow horizontal scrolling if needed
  }

  th,
  td {
    border: 1px dashed gray;
    padding: 8px; // Add some padding
  }
`

const StyledTypography = styled(Typography)<{ component?: string }>`
  p {
    margin: 0;
  }
`

export default function TabsContent({ data }: { data: any }) {
  const tabsContent = data?.properties?.[0]?.propertyValue?.blocks?.[0]
  const itemsList = extractProperty(tabsContent, "itemsList")
  const items = itemsList.map((item: any) => {
    return {
      content: extractProperty(item, "content"),
    }
  })
  return (
    <Container paddingMobile>
      <StyledProperty>
        <StyledTypography
          component="div"
          dangerouslySetInnerHTML={{
            __html: replaceRichTextLinks(items?.[0]?.content),
          }}
        />
      </StyledProperty>
    </Container>
  )
}
